import { PERCENTAGE } from "../util/Constants";

const UNIT_FORMATTERS = {
  COUNT: (value) => Math.round(value),
  PERCENT: (value) => `${Math.round(value)}${PERCENTAGE}`,
  // Future unit types can be easily added here:
  // CURRENCY: (value) => `$${value.toFixed(2)}`,
  // DECIMAL: (value) => value.toFixed(2),
  // TIME: (value) => `${Math.round(value)}s`,
};

const FormattedMetric = ({ value, unit, defaultValue = "-" }) => {
  // Handle null/undefined values
  if (value === null || value === undefined) {
    return defaultValue;
  }

  // Get the appropriate formatter for the unit type
  // Default to COUNT formatter if unit type is not recognized
  const formatter = UNIT_FORMATTERS[unit] || UNIT_FORMATTERS.COUNT;

  return formatter(value);
};

export default FormattedMetric;



// WEBPACK FOOTER //
// ./src/components/common/FormattedMetric.js